import React from 'react'
import UnderMaintenance from './components/UnderMaintenance'

const App = () => {
  return (
    <div>
      <UnderMaintenance/>
    </div>
  )
}

export default App